import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UndoHandlerService {

  constructor() { }

  private static getUndoList(arr) {
    if (!arr.$$undo) {
      arr.$$undo = [];
    }
    return arr.$$undo;
  }
  public resetUndo(arr) {
    if (arr.$$undo) {
      arr.$$undo = [];
    }
  }
  public addUndo(arr, item, index?) {
    const undoList = UndoHandlerService.getUndoList(arr);
    undoList.push({
      item: item,
      index: index
    });
    if (undoList.length > 50) {
      undoList.shift();
    }
  }
  public undo(arr) {
    const undoList = UndoHandlerService.getUndoList(arr);
    if (undoList.length > 0) {
      const undoItem = undoList.pop();
      if (undoItem.index !== undefined) {
        arr.splice(undoItem.index, 0, undoItem.item);
      } else {
        delete undoItem.item._destroy;
      }
    }
  }
}
